"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const workspaceMemoryToolRegistry = {
  getWorkspaceMemory: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./get-workspace-memory").then(
        ({ GetWorkspaceMemoryToolView }) => ({
          default: GetWorkspaceMemoryToolView,
        })
      )
    ),
  },
} satisfies ToolUIRegistry;
